import type { PlaylistItem } from '~/jet/models';
import { writable } from 'svelte/store';
import type { Writable } from 'svelte/store';

interface PlaylistData {
    playlistId?: string;
    title?: string;
    description?: string;
    songs?: string[];
    librarySongs?: string[];
    offset?: number;
}

export const playlists: Writable<any[] | null> = writable([]);
export const showNewPlaylistModal: Writable<boolean> = writable(false);
export const showEditPlaylistModal: Writable<boolean> = writable(false);
export const newPlaylistData: Writable<PlaylistData | null> = writable(null);
export const editPlaylistData: Writable<PlaylistData | null> = writable(null);

export const setPlaylists = (playlistItems: PlaylistItem[]) => {
    playlists.set(sortLibraryPlaylists(playlistItems));
};

export const pushNewPlaylist = (newPlaylist: PlaylistItem) => {
    playlists.update((navItems: PlaylistItem[]) => {
        const playlistsWithNewPlaylist = [...navItems, newPlaylist];
        return sortLibraryPlaylists(playlistsWithNewPlaylist);
    });
};

export const removePlaylist = (playlistId: string) => {
    playlists.update((navItems: PlaylistItem[]) => {
        const newPlaylists = navItems.filter(
            (item) => item.id?.resourceId !== playlistId,
        );
        return sortLibraryPlaylists(newPlaylists);
    });
};

export const updatePlaylistLabel = (playlistId: string, label: string) => {
    playlists.update((navItems: PlaylistItem[]) => {
        let newPlaylists = navItems.map((item) => {
            if (item.id?.resourceId === playlistId) {
                return { ...item, label };
            }
            return item;
        });
        return sortLibraryPlaylists(newPlaylists);
    });
};

function sortLibraryPlaylists(playlistItems: PlaylistItem[]) {
    return playlistItems?.sort((a, b) =>
        a?.label?.toLowerCase().localeCompare(b?.label?.toLowerCase()),
    );
}
